/*
  Creator-Empfehlungs-Banner (DEV-2026-0274).

  Liest ?creator=CRID aus der Adresse, sucht das passende Metaobjekt in den vom
  Liquid eingebetteten Daten und zeigt das Banner. Kein Treffer, kein Parameter,
  keine Daten → es bleibt unsichtbar. Ausdrücklich KEIN Platzhaltertext: ein
  Banner ohne Bild und ohne Link sieht bei kaputten Links wie ein Fehler aus.

  Ein einmal erkannter Creator gilt für den restlichen Tab-Besuch, auch ohne
  Parameter in der Folge-URL (DEV-2026-0297).
*/
(function () {
  'use strict';

  var VERIFIED_SVG =
    '<svg class="spz-creator-verified" viewBox="0 0 22 22" aria-hidden="true">' +
    '<path d="M11 0l2.6 1.5 3-.4 1 2.9 2.9 1-.4 3L22 11l-1.9 2.6.4 3-2.9 1-1 2.9-3-.4L11 22l-2.6-1.5-3 .4-1-2.9-2.9-1 .4-3L0 11l1.9-2.6-.4-3 2.9-1 1-2.9 3 .4L11 0z" fill="#3897F0"/>' +
    '<path d="M9.4 15.4l-4-4 1.4-1.5 2.6 2.6 6-6L16.9 8l-7.5 7.4z" fill="#fff"/>' +
    '</svg>';

  // DEV-2026-0297: Der Creator soll den ganzen Tab-Besuch begleiten. Interne
  // Links tragen ?creator= nicht weiter, sonst verschwindet das Banner beim
  // ersten Klick von der Landingpage weg.
  //
  // GESCHRIEBEN wird dieser Schluessel nicht hier, sondern im Layout
  // (snippets/attribution-tracker.liquid) — Nacharbeit zu DEV-2026-0297. Grund:
  // Dieses Skript laedt nur, wo das Banner steht, also auf Produktseiten.
  // Kampagnenlinks starten aber auf einer Landing- oder Kollektionsseite; wer
  // den Parameter erst auf der Produktseite mitschreibt, hat ihn dann schon
  // verloren — und das Banner blieb den ganzen Besuch aus.
  //
  // Der Speicher ist sessionStorage und ausdruecklich NICHT der 30-Tage-Wert,
  // den derselbe Tracker in localStorage fuer die Bestell-Zuordnung haelt: als
  // Anzeige-Quelle waere das falsch, sonst behauptet das Banner in zwei Wochen
  // noch eine Empfehlung.
  var SPEICHER = 'spz-creator-v1:crid';

  function creatorAusAdresse() {
    try {
      var wert = new URLSearchParams(window.location.search).get('creator');
      return wert ? wert.trim().toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function finde(daten, crid) {
    for (var i = 0; i < daten.length; i++) {
      if (String(daten[i].crid || '').toLowerCase() === crid) return daten[i];
    }
    return null;
  }

  function creatorDerSitzung() {
    // Parameter in der aktuellen Adresse gewinnt: wer einen neuen
    // Empfehlungslink oeffnet, soll den neuen Creator sehen, nicht den gemerkten.
    var ausAdresse = creatorAusAdresse();
    if (ausAdresse) return ausAdresse;
    try {
      var gemerkt = sessionStorage.getItem(SPEICHER);
      return gemerkt ? gemerkt.trim().toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function textKnoten(banner) {
    return banner.querySelector('.spz-creator-banner__text');
  }

  function zeige(banner, daten, gesuchteCrid) {
    var treffer = finde(daten, gesuchteCrid);
    // Kein Treffer → nichts anzeigen (Nachtrag im Ticket: kein Fallback-Text).
    if (!treffer || !treffer.instagram) return;

    var ziel = textKnoten(banner);
    if (!ziel) return;

    // Handle aus dem Metaobjekt: als Text setzen, nicht als HTML — sonst wäre
    // ein im Shopify-Admin gepflegter Wert eine Einfallstelle für Markup.
    var handleText = document.createElement('span');
    handleText.textContent = 'Empfohlen von @' + treffer.instagram + ' ';
    ziel.textContent = '';
    ziel.appendChild(handleText);

    var badge = document.createElement('span');
    badge.innerHTML = VERIFIED_SVG;
    ziel.appendChild(badge.firstChild);

    var zusatz = banner.getAttribute('data-zusatz') || 'und 10.000+ weiteren';
    ziel.appendChild(document.createTextNode(' ' + zusatz));

    banner.setAttribute('href', 'https://www.instagram.com/' + encodeURIComponent(treffer.instagram) + '/');
    banner.setAttribute('target', '_blank');
    banner.setAttribute('rel', 'noopener');
    banner.setAttribute('aria-label', 'Instagram-Profil von @' + treffer.instagram + ' öffnen');

    if (treffer.avatar) {
      var haupt = banner.querySelector('.spz-creator-avatar--main');
      var gruppe = banner.querySelector('.spz-creator-avatars');
      if (haupt && gruppe) {
        haupt.setAttribute('src', treffer.avatar);
        haupt.setAttribute('alt', 'Profilbild von @' + treffer.instagram);
        haupt.removeAttribute('hidden');
        gruppe.removeAttribute('hidden');
      }
    }

    banner.removeAttribute('hidden');
  }

  function start() {
    // querySelectorAll, nicht querySelector: der Block kann mehrfach auf einer
    // Seite stehen (Theme-Editor erlaubt das), und dann darf nicht nur der erste
    // erscheinen — genau dieser Fehler ist bei der Händlerkarte passiert.
    var banner = document.querySelectorAll('.spz-creator-banner');
    if (!banner.length) return;

    var quellen = document.querySelectorAll('.spz-creator-data');
    var daten = [];
    for (var q = 0; q < quellen.length; q++) {
      try {
        var teil = JSON.parse(quellen[q].textContent || '[]');
        if (Array.isArray(teil)) daten = daten.concat(teil);
      } catch (e) {
        /* defekte Daten dürfen die Seite nicht mitnehmen */
      }
    }
    if (!daten.length) return;

    // Ein unbekannter Wert (Tippfehler im Empfehlungslink, geloeschtes
    // Metaobjekt) laeuft in zeige() ins Leere und zeigt nichts — deshalb darf
    // hier ungeprueft weitergegeben werden, was der Tracker gemerkt hat.
    var crid = creatorDerSitzung();
    if (!crid) return;

    for (var b = 0; b < banner.length; b++) zeige(banner[b], daten, crid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
